import { Component, TemplateRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ProjeToPta } from 'src/app/shared/models/ProjetToPta';
import { ParameterService } from 'src/app/shared/service/params/param';
import { LocalStorageService } from 'src/app/shared/service/storage/localstorage.service';
import { Constant } from 'src/app/shared/service/utils/contant';

@Component({
  selector: 'app-add-tache-sous-activite',
  templateUrl: './add-tache-sous-activite.component.html',
  styleUrl: './add-tache-sous-activite.component.scss'
})

export class AddTacheSousActiviteComponent {

  item: any;
  activiteItems: any;
  tacheItems:any
  @ViewChild('sousActiviteModal') modalContent: TemplateRef<any>;
  newItem:ProjeToPta = new ProjeToPta ();
  updateItem:ProjeToPta = new ProjeToPta();
  totalRecords: number = 0; // Nombre total d'éléments
  firstProjets = 0;
  rowsProjets = 10;
  paginatedProjets = [];
  isLoading: boolean = false;

  constructor(

    private localStorage: LocalStorageService,
    private paramService: ParameterService,
    private messageService: MessageService,
    private ngxService: NgxUiLoaderService,
    private confirmationService: ConfirmationService,
    private modalService: NgbModal,
    private router: Router,

  ) { }


  ngOnInit() {


    this.item = this.localStorage.getTacheSousActivite();

    ////console.log("les item", this.item);
    this.getTacheToSousActivite();

  }


  getTacheToSousActivite(){
    this.isLoading = true;

    ////console.log("this.item",this.item.reference);
    
    this.paramService.getTacheToSousActivite(this.item.reference).subscribe(

      (response:any)=>{
        this.isLoading = false;

        ////console.log("la reponse du webservice",response);

        this.tacheItems= response.data;
        this.totalRecords = this.tacheItems.length; // Met à jour le total des enregistrements
        this.updatePaginatedProjets()
      },
      (error)=>{

        ////console.log("une erreur est survenu",error);
        
      }
    )
  }


  onPageChangeProjets(event) {
    this.firstProjets =  event.first;// Mise à jour de la page actuelle
    this.rowsProjets =  event.rows;// Mise à jour de la page actuelle
    this.updatePaginatedProjets();
  }
  
  // Méthode pour mettre à jour les données paginées des projets
  updatePaginatedProjets() {
    const start = this.firstProjets;
    const end = start + this.rowsProjets;
    this.paginatedProjets = this.tacheItems.slice(start, end);
  }
  saveSousActiviteToActivite() {

    this.newItem.pta_sous_activite_id = this.item.reference;

    ////console.log('this.newItem.projetId',this.newItem.pta_sous_activite_id);
    
    this.ngxService.start();
    this.paramService.saveTacheToSousActivite(this.newItem).subscribe(

      (response: any) => {

        ////console.log(" this.activiteItems", response);

        this.messageService.add({ severity: 'success', summary: Constant.suiviTitle, detail: response.message });
        this.newItem = new ProjeToPta();

        this.getTacheToSousActivite();
        this.ngxService.stop();
      },
      (error) => {

        ////console.log("une erreur est survenu", error);
        this.ngxService.stop();
        this.messageService.add({ severity: 'error', summary: Constant.suiviTitle, detail:"une erreur est survenu" });


      }
    )
  }


  pta_tache_id :any
  openModalTache(sousActivite: any) {
    ////console.log("sousActivite", sousActivite);

    this.updateItem = sousActivite;

    // Convertir la date_debut au format 'YYYY-MM-DD'
    this.updateItem.date_debut = sousActivite.date_debut.split('T')[0];
    this.updateItem.date_fin = sousActivite.date_fin.split('T')[0];

    ////console.log("this.updateItem.date_debut", this.updateItem.date_debut);
    
    // Ouvrir le modal en passant le template
    //this.updateItem.pta_activite_id = this.item.reference;
    this.updateItem.pta_sous_activite_id = this.item.reference;

     this.pta_tache_id = sousActivite.reference;
    ////console.log("this.updateItem.pta_activite_id", this.updateItem.pta_activite_id);
    
    this.modalService.open(this.modalContent, {
       size: 'ml',
       backdrop: 'static',
       keyboard: false
    });
}




  updateSousActiviteToActivite(){
    ////console.log('this.newItem.projetId',this.updateItem);

    this.ngxService.start();
    this.paramService.UpdateTacheToSousActivite(this.pta_tache_id , this.updateItem).subscribe(

      (response: any) => {

        ////console.log(" this.activiteItems", response);

        this.messageService.add({ severity: 'success', summary: Constant.suiviTitle, detail: response.message });

        this.getTacheToSousActivite();
        this.modalService.dismissAll()

        this.ngxService.stop();
      },
      (error) => {

        ////console.log("une erreur est survenu", error);
        this.ngxService.stop();
        this.messageService.add({ severity: 'error', summary: Constant.suiviTitle, detail:"une erreur est survenu" });


      }
    )
  }

  confirmDeletion(project: any) {
    this.confirmationService.confirm({
      message: 'Êtes-vous sûr de vouloir supprimer ce projet ' + project.libelle + '?',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      acceptIcon: 'pi pi-check',
      rejectIcon: 'pi pi-times',
      rejectButtonStyleClass: 'p-button-text',
      acceptLabel: 'Oui',
      rejectLabel: 'Non',
      accept: () => {
        this.ngxService.start();
        this.paramService.deleteTacheToSousActivite(project.reference).subscribe(
          (response: any) => {
            this.ngxService.stop();
            ////console.log("la reponse du webserice", response);
            this.messageService.add({ severity: 'success', summary: Constant.suiviTitle, detail: response.message });
            this.getTacheToSousActivite();
          },
          (error) => {
            this.ngxService.stop();
            ////console.log("une erreur est survenu", error);
            this.messageService.add({ severity: 'error', summary: Constant.suiviTitle, detail: "Une erreur est survenue. Veuillez réessayé" });
          },
        )
      },
      reject: () => {
        //this.messageService.add({ severity: 'warn', summary: '', detail: 'Vous avez rejeté', life: 3000 });
      }
    });
  }

  close(){

    this.modalService.dismissAll();
  }

  


}